// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eJ0Il","text":"Footer_text__uKcAi","containerImg":"Footer_containerImg__ByhCi","img":"Footer_img__G1QQ-"};